<div class="container layout layout--emergency">

    <div class="layout__emergency">

        <div class="layout__emergency-inner">
      
          <div class="card card--emergency">
           
            <div class="card-body">

              <div class="card__avatar card__avatar__code">
                <img src="assets\0\img\home\images-emergency-assistance-guy.svg" class="img-fluid" alt="">
              </div>  
              <h4>{{question.question_copy}}</h4>

              <div class="card__msg">
                <div class="rte">
                  <p>{{question.question_prompt}}</p>
                </div>
              </div>

              <div class="card__form">
                       
             <span class="assist-code">{{securityCode}}</span>                 


              </div>
          
            
          </div>

        </div>
              
    </div>

    <div>
      
    </div>
    
  </div>

  </div>